import { Box } from "@mui/material";
import Spinner from "./small";
interface IProps {
  sx?: any;
}

export default function MainSpinner(props: IProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        background: "rgba(255,255,255,0.8)",
        borderRadius: "8px",
        ...props.sx,
      }}
    >
      <Spinner />
    </Box>
  );
}
